import CTA11_2 from './CTA11_2.js'
export default CTA11_2
